var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.isShow)?_c('div',{staticClass:"a-notification-icon",style:({ 'min-width': _vm.size + 'px', 'height': _vm.size + 'px', 'border-radius': _vm.size + 'px' })},[(_vm.count)?_c('span',{staticClass:"a-notification-icon__text"},[_vm._v(_vm._s(_vm.formattedCount))]):_vm._e()]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }